var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire984b"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire984b"] = parcelRequire;
}

var $hrTe4 = parcelRequire("hrTe4");
var $9d99491d4b437af2$var$nav, $9d99491d4b437af2$var$ham, $9d99491d4b437af2$var$close, $9d99491d4b437af2$var$home, $9d99491d4b437af2$var$events, $9d99491d4b437af2$var$ff, $9d99491d4b437af2$var$wheel, $9d99491d4b437af2$var$myspace, $9d99491d4b437af2$var$logout;
var $9d99491d4b437af2$var$init = false;
window.addEventListener("load", ()=>{
    $9d99491d4b437af2$var$nav = document.querySelector("nav");
    $9d99491d4b437af2$var$ham = document.querySelector(".MMFOOD");
    $9d99491d4b437af2$var$close = document.querySelector(".mobile-close");
    $9d99491d4b437af2$var$home = document.querySelector("nav .home");
    $9d99491d4b437af2$var$events = document.querySelector("nav .events");
    $9d99491d4b437af2$var$ff = document.querySelector("nav .funfive");
    $9d99491d4b437af2$var$wheel = document.querySelector("nav .wheel");
    $9d99491d4b437af2$var$myspace = document.querySelector("nav .myspace");
    $9d99491d4b437af2$var$logout = document.querySelector("nav .logout");
    $9d99491d4b437af2$var$ham.addEventListener("click", $9d99491d4b437af2$var$mobileMenu);
    $9d99491d4b437af2$var$close.addEventListener("click", $9d99491d4b437af2$var$mobileMenu);
});
const $9d99491d4b437af2$var$mobileMenu = ()=>{
    $9d99491d4b437af2$var$nav.classList.toggle("mobile-menu");
    if ($9d99491d4b437af2$var$nav.classList.contains("mobile-menu")) {
        if (!$9d99491d4b437af2$var$init) {
            $9d99491d4b437af2$var$init = true;
            $9d99491d4b437af2$var$initFX();
        }
        document.getElementById("webgl").style.display = "block";
        const t = gsap.timeline();
        t.fromTo($9d99491d4b437af2$var$home, {
            opacity: 0
        }, {
            opacity: 1,
            duration: 0.5
        }, 0.1);
        t.fromTo($9d99491d4b437af2$var$events, {
            opacity: 0
        }, {
            opacity: 1,
            duration: 0.5
        }, 0.125);
        t.fromTo($9d99491d4b437af2$var$ff, {
            opacity: 0
        }, {
            opacity: 1,
            duration: 0.5
        }, 0.18);
        t.fromTo($9d99491d4b437af2$var$wheel, {
            opacity: 0
        }, {
            opacity: 1,
            duration: 0.5
        }, 0.21);
        t.fromTo($9d99491d4b437af2$var$myspace, {
            opacity: 0
        }, {
            opacity: 1,
            duration: 0.5
        }, 0.24);
        t.fromTo($9d99491d4b437af2$var$logout, {
            opacity: 0
        }, {
            opacity: 1,
            duration: 0.5
        }, 0.3);
        t.fromTo($9d99491d4b437af2$var$home, {
            translateY: "75px"
        }, {
            translateY: "0px",
            duration: 0.75,
            ease: "elastic.out(1, 0.5)"
        }, 0.1);
        t.fromTo($9d99491d4b437af2$var$events, {
            translateY: "95px"
        }, {
            translateY: "0px",
            duration: 0.75,
            ease: "elastic.out(1, 0.5)"
        }, 0.125);
        t.fromTo($9d99491d4b437af2$var$ff, {
            translateY: "105px"
        }, {
            translateY: "0px",
            duration: 0.75,
            ease: "elastic.out(1, 0.5)"
        }, 0.18);
        t.fromTo($9d99491d4b437af2$var$wheel, {
            translateY: "115px"
        }, {
            translateY: "0px",
            duration: 0.75,
            ease: "elastic.out(1, 0.5)"
        }, 0.21);
        t.fromTo($9d99491d4b437af2$var$myspace, {
            translateY: "125px"
        }, {
            translateY: "0px",
            duration: 0.75,
            ease: "elastic.out(1, 0.5)"
        }, 0.24);
        t.fromTo($9d99491d4b437af2$var$logout, {
            translateY: "155px"
        }, {
            translateY: "0px",
            duration: 0.75,
            ease: "elastic.out(1, 0.5)"
        }, 0.3);
        t.fromTo($9d99491d4b437af2$var$home, {
            scale: 0.25
        }, {
            scale: 1,
            duration: 0.85,
            ease: "elastic.out(1.5, 0.75)"
        }, 0.1);
        t.fromTo($9d99491d4b437af2$var$events, {
            scale: 0.25
        }, {
            scale: 1,
            duration: 0.85,
            ease: "elastic.out(1.5, 0.75)"
        }, 0.125);
        t.fromTo($9d99491d4b437af2$var$ff, {
            scale: 0.25
        }, {
            scale: 1,
            duration: 0.85,
            ease: "elastic.out(1.5, 0.75)"
        }, 0.18);
        t.fromTo($9d99491d4b437af2$var$wheel, {
            scale: 0.25
        }, {
            scale: 1,
            duration: 0.85,
            ease: "elastic.out(1.5, 0.75)"
        }, 0.21);
        t.fromTo($9d99491d4b437af2$var$myspace, {
            scale: 0.25
        }, {
            scale: 1,
            duration: 0.85,
            ease: "elastic.out(1.5, 0.75)"
        }, 0.24);
        t.fromTo($9d99491d4b437af2$var$logout, {
            scale: 0.25
        }, {
            scale: 1,
            duration: 0.85,
            ease: "elastic.out(1.5, 0.75)"
        }, 0.3);
    } else document.getElementById("webgl").style.display = "none";
};
const $9d99491d4b437af2$var$initFX = ()=>{
    (0, $hrTe4.initializeFX)(document.getElementById("webgl"), null, null, false, "nav");
};


//# sourceMappingURL=events.e217a4cb.js.map
